import { PopupStoreListPage } from './PopupStoreListPage';

export const popupStoreListRouter = {
  '/@/popup-store': PopupStoreListPage,
};
